import SummarizePromo from './SummarizePromo'
export default SummarizePromo